module.exports = __webpack_public_path__ + "static/media/Star-1.4272a237.svg";